import { v4 as uuidv4 } from "uuid";
export class CumulativeProjectReportEntryModel {
    constructor() {
        this.id = uuidv4();
        this.date = null;
        this.dateAsString = "";
        this.employeeId = null;
        this.employeeName = "";
        this.employeeDisplayString = "";
        this.taskDisplayString = "";
        this.totalTimeInHours = "";
    }
}
export default class CumulativeProjectReportEntry extends CumulativeProjectReportEntryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
